/** Mois courant au format `YYYY-MM`, attendu par l'API. */
export function currentMonth(): string {
  const now = new Date()
  return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}`
}

/**
 * Les `count` derniers mois au format `YYYY-MM`, du plus récent au plus ancien,
 * en partant de `from` (mois courant par défaut).
 *
 * Aucun mois futur n'est produit : le compteur d'activité n'y a rien à lire.
 */
export function recentMonths(count: number, from: string = currentMonth()): string[] {
  const [year, index] = from.split('-').map(Number)
  if (!year || !index) return []
  return Array.from({ length: Math.max(0, count) }, (_, offset) => {
    const date = new Date(Date.UTC(year, index - 1 - offset, 1))
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`
  })
}

/** `2026-08` → « août 2026 », pour l'affichage. */
export function formatMonthLabel(month: string, locale: string): string {
  const [year, index] = month.split('-').map(Number)
  if (!year || !index) return month
  return new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : 'fr-FR', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, index - 1, 1)))
}
